import { RSAA } from 'redux-api-middleware';

import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/categories/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/categories/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/categories/LOAD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadCategories() {
  return {
    [RSAA]: {
      ...api.getCategories(),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
      bailout: store => store.categories && store.categories.data.length > 1,
    },
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: {
    categories: [],
    tags: [],
  },
};

export default function categoriesReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
}

// ------------------------------------
// Selectors
// ------------------------------------

export function getCategoryName(globalState, categorySeoName) {
  const category = globalState.categories.data.categories.find(
    category => category.seoName === categorySeoName
  );
  return (category && category.name) || '';
}

export function getCategoryDescription(globalState, categorySeoName) {
  const category = globalState.categories.data.categories.find(
    category => category.seoName === categorySeoName
  );
  return (category && category.description) || '';
}

export function getSubcategoryName(globalState, subcategorySeoName) {
  const subcategories = globalState.categories.data.categories.reduce(
    (subcategories, category) => {
      return [...subcategories, ...category.subcategories];
    },
    []
  );
  const subcategory = subcategories.find(
    subcategory => subcategory.seoName === subcategorySeoName
  );
  return (subcategory && subcategory.name) || '';
}

export function getSubcategoryDescription(globalState, subcategorySeoName) {
  const subcategories = globalState.categories.data.categories.reduce(
    (subcategories, category) => {
      return [...subcategories, ...category.subcategories];
    },
    []
  );
  const subcategory = subcategories.find(
    subcategory => subcategory.seoName === subcategorySeoName
  );
  return (subcategory && subcategory.description) || '';
}

export function getCategoryType(globalState, categorySeoName) {
  const category = globalState.categories.data.categories.find(
    category => category.seoName === categorySeoName
  );
  return category && category.type;
}

export function getCategoriesByType(globalState, type) {
  const categories = globalState.categories.data.categories;

  if (type) {
    return categories.filter(category => category.type === type);
  }

  // If type is not specified (i.e. Search Page, return all the categories)
  return categories;
}
